(function () {
    angular.module('charts')
      .directive("assignmentInfo", function () {
          return {
              restrict: "E",
              scope: {
                  assignment: '=',
                  showClassroom: '=',
                  showBasic: '='
              },
              transclude: true,
              templateUrl: '/resources/charts/partials/assignment-info.html',
              controller: [
                  '$scope',
                  '$state',
                  'authentication',
                  'moment',
                  'assignedFocusApi',
                  'dblLessonService',
                  AssignmentInfoController]
          };
      });

    function AssignmentInfoController(
      $scope,
      $state,
      dblAuthentication,
      moment,
      $assignedFocusApi,
      dblLessonService
    ) {

        $scope.handlePlayDemoLessonClick = handlePlayDemoLessonClick;
        $scope.onCancelClicked = onCancelClicked;
        $scope.onViewProgressClick = onViewProgressClick;
        $scope.isDomainAssignment = isDomainAssignment;

        $scope.head = {
            cteacher: {title: 'assignments.assignedByTitle', show: true},
            classroom: {title: 'assignments.classroomTitle', show: false},
            duration: {title: 'assignments.timeSpentTitle', show: true},
            progress: {title: 'assignments.lessons', show: true}
        };

        var customer = dblAuthentication.getCustomer();

        function getDurationInWeeks(start_date, end_date) {
            var end = moment(end_date);
            var start = moment(start_date);

            return end.diff(start, 'weeks');
        }

        $scope.$watch('assignment', function () {
            if ($scope.assignment) {
                $scope.isOngoing = $assignedFocusApi.isLongTermAssignment($scope.assignment);
                $scope.assignment.duration = getDurationInWeeks($scope.assignment.start_date, $scope.assignment.end_date);
                $scope.assignment.lesson_goal_name = $assignedFocusApi.validateLessonGoalName($scope.assignment.lesson_goal_name);

                $scope.assignment.assessment = $assignedFocusApi.thirdPartyTitle($scope.assignment);
                $scope.assignment.isNwea = $assignedFocusApi.isNweaAssignment($scope.assignment);
                $scope.assignment.isLegacyNWEA = $assignedFocusApi.isLegacyNwea($scope.assignment);
                if ($scope.head.lessons) {
                    $scope.head.lessons.show = true;
                }
            }
        });

        $scope.$watch('showClassroom', function () {
            if ($scope.showClassroom) {
                $scope.head.classroom.show = true;
            }
        });

        // studentDistrictId is equal to -1 for students that aren't in classrooms
        $scope.allowCancel = $state.current.name === 'guardian' ? $state.params.studentDistrictId === '-1' || customer.hasTag('ASSIGN_FOCUS_ENABLED') : true;

        function handlePlayDemoLessonClick($event) {
            $event.stopPropagation();

            if ($scope.assignment && $scope.assignment.student_assignment_histories && $scope.assignment.student_assignment_histories.length > 0) {
                dblLessonService.openPlayLessonLink($scope.assignment.student_assignment_histories[0].lesson_slot_id);
            }
        }

        function onCancelClicked() {
            $scope.$emit('cancelAssignmentClicked', $scope.assignment);
        }

        function onViewProgressClick() {
            $scope.$emit('viewProgressClick', $scope.assignment);
        }

        function isDomainAssignment(assignment) {
            return assignment.focus_type === 'DOMAIN';
        }
    }
})();
